import { PropTypes } from 'base/react-libs';
import Interaction from 'apps/interactions/components/interaction';
import InteractionTypeCell from 'apps/interactions/components/cells/interaction-type-cell';
import InteractionDateCell from 'apps/interactions/components/cells/interaction-date-cell';

const InteractionSnippetCard = ({ interaction = {}, highlight = '', contactId = 0 }) => {
  return (
    <div className="interaction-snippet-card">
      <InteractionTypeCell interaction={interaction} />
      <Interaction
        props={{
          interaction,
          highlight,
          showSummary: true,
          contactId,
          fromGlobalSearch: true,
        }}
        clickable={true}
      />
      <InteractionDateCell interaction={interaction} />
    </div>
  );
};

InteractionSnippetCard.propTypes = {
  interaction: PropTypes.object.isRequired,
  highlight: PropTypes.string,
  contactId: PropTypes.number,
};

export default InteractionSnippetCard;
